import initialState from './state'

export default {
  resetPortalHomeSession(state) {
    Object.assign(state, initialState())
  },
  setHomeInitialInfo(state, payload) {
    state.homeInitialInfo = {
      cantTurnos: Number(payload?.cantTurnos ?? 0) || 0,
      cantInformesDiagImg: Number(payload?.cantInformesDiagImg ?? 0) || 0,
      cantInformesLab: Number(payload?.cantInformesLab ?? 0) || 0,
      otrosDocumentos: Number(payload?.otrosDocumentos ?? 0) || 0,
      cantEpicrisis: Number(payload?.cantEpicrisis ?? 0) || 0,
    }
  },
  setHomeMenu(state, tree) {
    state.menuTree = Array.isArray(tree) ? [...tree] : []
  },
  setHomeMenuLoading(state, loading) {
    state.menuLoading = !!loading
  },
  setHomeMenuError(state, error) {
    state.menuError = error ?? null
  },
  setHomeProfile(state, { nombre = '', apellido = '' }) {
    state.profileNombre = String(nombre ?? '').trim()
    state.profileApellido = String(apellido ?? '').trim()
  },
  setActivePortalFicha(state, payload) {
    const id = Number(payload?.fichaId)
    state.activePortalFichaId = Number.isFinite(id) && id > 0 ? id : null
    state.activePortalNombre = String(payload?.nombre ?? '').trim()
    state.activePortalParentesco = String(payload?.parentesco ?? '').trim()
    state.turnosPendientes = { ...state.turnosPendientes, fetched: false }
    state.turnosHistorial = { ...state.turnosHistorial, fetched: false }
  },
  setInformesHome(state, patch) {
    state.informesHome = { ...state.informesHome, ...patch }
  },
  setInformesDiagnosticosPage(state, patch) {
    state.informesDiagnosticosPage = {
      ...state.informesDiagnosticosPage,
      ...patch,
    }
  },
  setResultadosLaboratorioPage(state, patch) {
    state.resultadosLaboratorioPage = {
      ...state.resultadosLaboratorioPage,
      ...patch,
    }
  },
  setOtrosDocumentosPage(state, patch) {
    state.otrosDocumentosPage = {
      ...state.otrosDocumentosPage,
      ...patch,
    }
  },
  setAdmissionsPage(state, patch) {
    state.admissionsPage = {
      ...state.admissionsPage,
      ...patch,
    }
  },
  setPedidosMedicosPage(state, patch) {
    state.pedidosMedicosPage = {
      ...state.pedidosMedicosPage,
      ...patch,
    }
  },
  setPortalPrivateParams(state, patch) {
    state.portalPrivateParams = { ...state.portalPrivateParams, ...patch }
  },
  setTurnosPendientes(state, patch) {
    state.turnosPendientes = { ...state.turnosPendientes, ...patch }
  },
  setTurnosHistorial(state, patch) {
    state.turnosHistorial = { ...state.turnosHistorial, ...patch }
  },
}
